<script>
  let { variant = 'dashed', spacing = 'md' } = $props();

  const spacingMap = { sm: '8px', md: '16px', lg: '24px' };
</script>

<div
  class="receipt-divider receipt-divider--{variant}"
  style:padding-top={spacingMap[spacing]}
  style:padding-bottom={spacingMap[spacing]}
>
  {#if variant === 'stars'}
    <span class="receipt-divider__stars">* * * * * * * * * *</span>
  {:else}
    <hr class="receipt-divider__line" />
  {/if}
</div>

<style>
  .receipt-divider {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .receipt-divider__line {
    width: 100%;
    border: none;
    margin: 0;
  }

  .receipt-divider--dashed .receipt-divider__line {
    border-top: 1px dashed var(--receipt-divider);
  }

  .receipt-divider--dotted .receipt-divider__line {
    border-top: 2px dotted var(--receipt-divider);
  }

  .receipt-divider--double .receipt-divider__line {
    border-top: 3px double var(--receipt-divider-strong);
  }

  .receipt-divider__stars {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-meta);
    color: var(--receipt-text-muted);
    letter-spacing: 2px;
    text-align: center;
    user-select: none;
  }
</style>
